module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Away_With_the_Fairies2#Contents-A"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The strong subject, notwithstanding the efforts against him, survives and acquires fresh vigour. The people again cherish their sovereign, and the plotters have wrought their own overthrow.")])]), _vm._v(" "), _c('p', {
    staticClass: "quote-by"
  }, [_vm._v("Hexagram 23: Po"), _c('br', {
    staticClass: "calibre2"
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The I Ching Book of Changes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f5b6e02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Away_With_the_Fairies-4.vue
// module id = 72
// module chunks = 0